import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import animations from './animations';

gsap.registerPlugin(ScrollTrigger);

const getAnimElements = () => document.querySelectorAll('[data-anim-in]');

const init = () => {
    const elements = getAnimElements();
    if (!elements) return;

    elements.forEach((element) => {
        gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: `top ${element.dataset.start === undefined ? '85%' : element.dataset.start}`,
                onEnter: () => {
                    if (element.dataset.animated === undefined) {
                        element.dataset.animIn = true;
                        animations[element.dataset.animType](element);
                        element.dataset.animated = true;
                    }
                },
            },
        });
    });
};

export default init;
